export default () => ({
  scrolling: false,
  init() {
    if (window.location.hash) {
      window.scrollTo(0, 0);
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollTo(window.location.hash);
        }, 300);
      });
    }
  },
  scrollTo(hash) {
    let anchor = document.querySelector(hash);
    if (anchor) {
      const header = document.querySelector('header');
      const headerBox = header.getBoundingClientRect();
      const anchorBox = anchor.getBoundingClientRect();

      history.replaceState(null, null, hash);

      window.scrollTo({
        top: anchorBox.top + window.scrollY - headerBox.height,
        behavior: 'smooth',
      });
    }
  },
});